import { Box, Typography } from '@mui/material'
import First from '../../img/banner1.jpg'
import Second from '../../img/banner3.jpg'
import Third from '../../img/banner6.jpg'
import Footer from '../Shared/Footer'
import SiteHeader from '../Shared/SiteHeader'

const features = [
  {
    image: First,
    title: 'A Bond for Life',
    description: 'Celebrate the commitment that ties two hearts together forever.',
  },
  {
    image: Second,
    title: 'A Journey Together',
    description: 'Navigate every chapter of your relationship with shared purpose.',
  },
  {
    image: Third,
    title: 'A Celebration of Traditions',
    description: 'Honor heritage while building something uniquely yours.',
  },
]

export const AboutUs = () => {
  return (
    <div className='page-shell'>
      <SiteHeader />
      <Box className='page-content'>
        <Box className='page-container'>
          <Box className='section-header'>
            <Typography component='h1' className='section-title'>
              About Us
            </Typography>
            <Typography className='section-subtitle'>
              Three milestones. One beautiful journey. Discover what makes 3Knots special.
            </Typography>
          </Box>

          <Box className='feature-grid'>
            {features.map((item) => (
              <article key={item.title} className='feature-card'>
                <Box className='feature-card__image-wrap'>
                  <Box
                    component='img'
                    src={item.image}
                    alt={item.title}
                    className='feature-card__image'
                  />
                </Box>
                <Box className='feature-card__body'>
                  <Typography component='h2' className='feature-card__title'>
                    {item.title}
                  </Typography>
                  <Typography className='feature-card__desc'>
                    {item.description}
                  </Typography>
                </Box>
              </article>
            ))}
          </Box>
        </Box>
      </Box>
      <Footer />
    </div>
  )
}
